import React from 'react';
import { Container, Stack, Typography } from '@mui/material';

import RawHtml from '../../legacy/components/base/RawHtml';

// ********************************************************************************
type Props = { title: string; description: string };
export const TitleDescription: React.FC<Props> = ({ title, description }) => {
  // == Render ====================================================================
  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Stack spacing={3}>
        <Typography variant="h2" color="#3F2B56" fontFamily="Gotham-Medium" fontSize="32px" align="left">
          {title}
        </Typography>
        <Typography variant="body1" color="#302F2F" fontSize="16px" textAlign="left" lineHeight="20px" mt={2}>
          <RawHtml content={description} />
        </Typography>
      </Stack>
    </Container>
  );
};
